<script setup>
import { Transition } from 'vue';
import { ROOM_SIDE_CORRIDOR, ROOM_SIDE_ROOM } from '../../constants/roomSides';
import { useConfiguratorStore } from '../../stores/configurator';
import { useUiStore } from '../../stores/ui';
import ListOptions from '../Form/ListOptions.vue';

const configurationStore = useConfiguratorStore();
const uiStore = useUiStore();
</script>

<template>
    <Transition
        enter-active-class="tw-transition tw-transform tw-duration-500 tw-ease-in-out"
        leave-active-class="tw-transition tw-transform tw-duration-500 tw-ease-in-out"
        enter-from-class="tw-translate-y-full lg:tw-translate-y-0 lg:-tw-translate-x-full"
        enter-to-class="tw-translate-y-0 lg:tw-translate-x-0"
        leave-from-class="tw-translate-y-0 lg:tw-translate-x-0"
        leave-to-class="tw-translate-y-full lg:tw-translate-y-0 lg:-tw-translate-x-full"
    >
        <section
            class="ConfiguratorOverlay tw-bg-white tw-w-full height-screen-minus-35-vw tw-overflow-y-auto tw-smooth-scroll tw-pt-4.5 md:tw-pt-8 lg:tw-pt-12 tw-px-4 md:tw-px-7 lg:tw-px-10 tw-pb-18 lg:tw-pb-20 lg:tw-h-auto lg:tw-max-w-md tw-text-gray-700 tw-absolute lg:tw-top-0 tw-bottom-0 tw-left-0 tw-right-0 lg:tw-right-auto tw-z-50 lg:tw-z-40"
            v-show="uiStore.showOverlayConfig"
        >
            <section
                class="ConfiguratorRoom"
                v-if="uiStore.showRoomConfig"
            >
                <div
                    class="ConfiguratorRoomSide"
                    v-if="configurationStore.configuration.roomSide === ROOM_SIDE_CORRIDOR"
                >
                    <ListOptions
                        :options="configurationStore.roomOptionsCorridor"
                        v-model="configurationStore.configuration.room[ROOM_SIDE_CORRIDOR]"
                        name="room"
                    />
                </div>

                <div
                    class="ConfiguratorRoomSide"
                    v-if="configurationStore.configuration.roomSide === ROOM_SIDE_ROOM"
                >
                    <ListOptions
                        :options="configurationStore.roomOptionsRoom"
                        v-model="configurationStore.configuration.room[ROOM_SIDE_ROOM]"
                        name="room"
                    />
                </div>
            </section>

            <section
                class="ConfiguratorFloor"
                v-if="uiStore.showFloorConfig"
            >
                <div
                    class="ConfiguratorRoomSide"
                    v-if="configurationStore.configuration.roomSide === ROOM_SIDE_CORRIDOR"
                >
                    <ListOptions
                        :options="configurationStore.floorOptionsCorridor"
                        v-model="configurationStore.configuration.floor[ROOM_SIDE_CORRIDOR]"
                        name="floor"
                    />
                </div>

                <div
                    class="ConfiguratorRoomSide"
                    v-if="configurationStore.configuration.roomSide === ROOM_SIDE_ROOM"
                >
                    <ListOptions
                        :options="configurationStore.floorOptionsRoom"
                        v-model="configurationStore.configuration.floor[ROOM_SIDE_ROOM]"
                        name="floor"
                    />
                </div>
            </section>

            <div class="tw-hidden tw-absolute tw-left-0 tw-bottom-20 tw-right-0 tw-h-px tw-bg-gray-100 lg:tw-block"></div>
        </section>
    </Transition>
</template>